/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import AlertDialog from '../../../common/alertDialog/AlertDialog';

const ConfirmationDialog = (props) => {
  const { showPopup, onHandleConfirm, onHandleCancel, popupConfig } = props;

  return (
    <AlertDialog
      isOpen={showPopup}
      showCancelButton={true}
      showCloseButton={false}
      title={popupConfig.titleText}
      message={popupConfig.messageText}
      cancelButtonMessage={popupConfig.cancelButtonText}
      confirmButtonMessage={popupConfig.confirmButtonText}
      isImportantMessage={popupConfig.type === 'warning'}
      handleConfirmButton={onHandleConfirm}
      handleCancelButton={onHandleCancel}
      handleCloseButton={onHandleCancel}
    />
  );
};

export default ConfirmationDialog;
